import axios, { ResponseType } from '~/api/axios';
import { Amount, Consent, Payroll, Transaction } from '~/types';

export const getPayrolls =
  (params: Record<string, any>) =>
  (): ResponseType<{ cursors?: { prev?: string; next?: string }; payrolls: Payroll[] }> => {
    return axios.get('/payrolls', { params: params });
  };

export const getPayrollsById = (id: string): ResponseType<Payroll> => {
  return axios.get(`/payrolls/${id}`);
};

export type CheckResponse = { fileId?: string; isOk: boolean } & { data: Partial<Payroll> };
export const sendCSVFile = (params: {
  amount: number;
  numberOfRecords: number;
  currency: string;
  file: any;
}): ResponseType<CheckResponse> => {
  const { amount, numberOfRecords, currency, file } = params;

  const data = new FormData();
  data.append('file', file.file);
  data.append('amount', amount.toString());
  data.append('numberOfRecords', numberOfRecords.toString());
  data.append('currency', currency);

  return axios.post(`/payrolls/check`, data, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export interface PayrollConsentData {
  fileId: string;
  amount: Amount;
  numberOfRecords: number;
}

export const createPayrollConsent = (
  body: PayrollConsentData
): ResponseType<{ consent: Consent; payroll: Payroll }> => {
  return axios.post('/payrolls/consent', body);
};

export const makePayrollTransfer = (
  consentId: string
): ResponseType<{ transaction: Transaction; payroll: Payroll }> => {
  return axios.post(`/payrolls`, { consentId });
};
